import { Check } from 'lucide-react';
import { cn } from 'helpers/cn';

type StepTitleProps = { number: number; title: string; state: 'current' | 'done' | 'upcoming' };

/** A step's numbered circle and heading: accent while current, a check once done. */
export const StepTitle = ({ number, title, state }: StepTitleProps) => (
  <div className="flex items-center gap-2.5">
    <span
      aria-hidden="true"
      className={cn(
        'num flex size-[22px] items-center justify-center rounded-full text-nano',
        state === 'current' && 'bg-accent text-white',
        state === 'done' && 'bg-ok-bg border-ok-line text-ok border',
        state === 'upcoming' && 'border-input text-dim border',
      )}
    >
      {state === 'done' ? <Check className="size-3" strokeWidth={2} /> : number}
    </span>
    <h2 className="text-foreground m-0 text-lede font-medium">{title}</h2>
  </div>
);
